module.exports = __webpack_public_path__ + "img/rice.84e4b0e0.png";